import { Component, Input } from '@angular/core';
export class NgxFormHeaderComponent {
   item: any = {}
   title: string = null
   icon: string = null
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'ngx-form-header',
  template: `
    <i *ngIf="icon" [class]="icon"></i>
    <span *ngIf="!title && item.id">Edit</span>
    <span *ngIf="!title && !item.id">Add</span>
    <span *ngIf="title">{{title}}</span>
  `,
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'item': [{ type: Input },],
'title': [{ type: Input },],
'icon': [{ type: Input },],
};
}

function NgxFormHeaderComponent_tsickle_Closure_declarations() {
/** @type {?} */
NgxFormHeaderComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
NgxFormHeaderComponent.ctorParameters;
/** @type {?} */
NgxFormHeaderComponent.propDecorators;
/** @type {?} */
NgxFormHeaderComponent.prototype.item;
/** @type {?} */
NgxFormHeaderComponent.prototype.title;
/** @type {?} */
NgxFormHeaderComponent.prototype.icon;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
